import { useLocation } from "@gatsbyjs/reach-router";
import { Button, Icon, TreeMenu } from "@whitespace/components";
import { usePrevious } from "@whitespace/gatsby-hooks";
import { useMenu } from "@whitespace/gatsby-theme-wordpress-basic/src/hooks/menus";
import clsx from "clsx";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import HelpMenu from "../../../components/HelpMenu";
import flatListToHierarchical from "../../../utils/flatListHierarchial";

import * as defaultStyles from "./HeaderFlyOutMenu.module.css";

HeaderFlyOutMenu.propTypes = {
  styles: PropTypes.objectOf(PropTypes.string),
  className: PropTypes.string,
};

export default function HeaderFlyOutMenu({
  styles = defaultStyles,
  className,
  ...restProps
}) {
  const { t } = useTranslation();
  const location = useLocation();
  const prevLocation = usePrevious(location);
  const [expanded, setExpanded] = useState(false);

  const mainMenu = useMenu("MAIN_MENU");
  const items = flatListToHierarchical(mainMenu?.items);

  useEffect(() => {
    if (typeof document !== "undefined") {
      document.documentElement.classList.toggle("overlay--active", expanded);
    }
  }, [expanded]);

  useEffect(() => {
    if (location !== prevLocation) {
      setExpanded(false);
    }
  }, [location, prevLocation]);
  return (
    <div className={clsx(styles.component, className)} {...restProps}>
      <Button
        type="button"
        onClick={() => setExpanded(!expanded)}
        aria-expanded={expanded}
        aria-controls="overlay-menu"
        className={styles.toggle}
      >
        {expanded ? (
          <>
            <Icon name="close" />
            {t("menuLabelClose")}
          </>
        ) : (
          <>
            <Icon name="menu" />
            <span className={styles.label}>{t("menuLabel")}</span>
          </>
        )}
      </Button>
      {expanded && (
        <>
          <div className={styles.backdrop} onClick={() => setExpanded(false)} />
          <div id="overlay-menu" className={styles.overlay}>
            {mainMenu && mainMenu.items && (
              <TreeMenu
                items={items}
                aria-label={t("mainMenu")}
                location={location}
                className={clsx(styles.mainMenu)}
              />
            )}
            <HelpMenu />
          </div>
        </>
      )}
    </div>
  );
}
